import { ITrainingTemplate } from '../domains/TrainingTemplate';
import { api } from './api';

interface ISplitPayload {
  exercises: { exercise_id: string }[];
}

interface ITrainingTemplatePayload {
  name: string;
  focus: string;
  splits: ISplitPayload[];
}

class TrainingTemplatesService {
  private apiService = api;

  public async getAll() {
    return this.apiService.get<ITrainingTemplate[]>('trainings/templates');
  }

  public async getById(id: string) {
    return this.apiService.get<ITrainingTemplate>(`trainings/templates/${id}`);
  }

  public async create(data: ITrainingTemplatePayload) {
    return this.apiService.post<ITrainingTemplate>(
      'trainings/templates',
      data,
    );
  }

  public async update(id: string, data: ITrainingTemplatePayload) {
    return this.apiService.put<ITrainingTemplate>(
      `trainings/templates/${id}`,
      data,
    );
  }

  public async remove(id: string) {
    return this.apiService.delete(`trainings/templates/${id}`);
  }
}

export { TrainingTemplatesService };
